import { Box } from "@mui/material";
import VideoCallContainer from "components/video/VideoCallContainer";
import FlexPage from "components/layout/FlexPage";
import { useRef } from "react";
import PreJoinScreen, { PreJoinScreenRef } from "./PreJoinScreen";
import { LocalUserChoices } from "@livekit/components-react";

export default ({
  isCallActive,
  onReJoin,
}: {
  isCallActive: boolean;
  onReJoin: (choices?: LocalUserChoices) => void;
}) => {
  const preJoinRef = useRef<PreJoinScreenRef>(null);

  const handlePreJoinComplete = () => {
    const choices = preJoinRef.current?.getCurrentChoices();
    onReJoin(choices);
  };

  return (
    <FlexPage fullHeight headerPadding={false} sx={{ maxWidth: "none" }}>
      {isCallActive ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "12px",
            overflow: "hidden",
            position: "relative",
            maxWidth: "none",
          }}
        >
          <VideoCallContainer
            containerId="video-main-container"
            containerType="main"
            style={{ maxWidth: "none" }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            padding: "20px",
            backgroundColor: "#1a1a1a",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              backgroundColor: "#232323",
              borderRadius: "12px",
              overflow: "hidden",
              aspectRatio: "4/3",
            }}
          >
            <PreJoinScreen
              ref={preJoinRef}
              containerized={true}
              onJoin={handlePreJoinComplete}
              showJoinButton={true}
            />
          </Box>
        </Box>
      )}
    </FlexPage>
  );
};
